<div class="position-relative">
  <div class="container-fluid">
    <div *ngIf="roomLists">
      <div class="row m-t-10" *ngIf="roomLists.length == 0">
        <div class="col-md-10 col-md-offset-1">
          <mat-card>
            {{ rGuestBookMessages?.book?.bookMessage2 || "Your cart is empty." }}
          </mat-card>
        </div>
      </div>
      <div class="row" *ngIf="roomLists?.length > 0">
        <div class="m-t-15 col-xs-12 col-sm-12 col-md-8 col-md-offset-2 guest-block custom-col mb-4">
          <div class="panel panel-default guest-info-block border">
            <div class="panel-heading" role="tab">
              <h4 class="panel-title custom-panel-title">
                <a role="button" class="main-top-heading nohover">
                  {{ rGuestBookMessages?.book?.bookMessage10 || "GUEST INFORMATION" }}
                </a>
              </h4>
            </div>
            <div id="collapseOne" class="panel-collapse collapse show custom-panel-content" role="tabpanel">
              <div class="sub-header col-xs-12 col-md-12 title-content">
                <span class="pull-right"> {{ rGuestBookMessages?.book?.bookMessage4 || "* Denotes a required field" }}</span>
              </div>
              <div class="row form-content">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-md-12 personal-information">
                    <div class="accordion">
                      <form #guestDetailsForm="ngForm" novalidate id="guestDetailsForm">
                        <div *ngFor="let rooms of roomLists; let roomIndex = index" class="accordion-section">
                          <a class="accordion-section-title active" id="accordion-a-{{ roomIndex }}" href="javascript:void(0)"
                            >{{ rGuestBookMessages?.book?.bookPageRoomText || "Room" }} {{ roomIndex + 1 }}
                            <span class="bookroomname">({{ rooms.room.roomName | pcapitalize: disableCapitalizePipe }})</span>
                          </a>
                          <div id="accordion-{{ roomIndex }}" class="accordion-section-content guest-accordion display-block">
                            <ng-container *ngFor="let guest of rooms.guestDetails; trackBy: customTrackBy; let i = index">
                              <div
                                [ngStyle]="{ border: guest.casinoValidateFalse ? '3px solid #f44336' : '' }"
                                *ngIf="guest.action !== 'DELETE'"
                                [@anim]="guest.removeStat"
                                class="item panel panel-border panel-default position-relative">
                                <app-loader
                                  *ngIf="guest.reloadwindow"
                                  [loaderMsg]="rGuestBookMessages?.confirmation?.processingLoaderText || 'Processing...'"
                                  [fullWidth]="false"></app-loader>
                                <div *ngIf="guest.reloadwindow" class="reload-window"></div>
                                <div
                                  class="panel-heading"
                                  [ngClass]="guest.casinoValidateFalse ? 'errorPlanelHeader' : ''"
                                  role="tab"
                                  id="heading{{ i }}">
                                  <h4 class="panel-title custom-panel-title">
                                    <i class="fa fa-address-card" aria-hidden="true"></i>
                                    <a
                                      role="button"
                                      data-toggle="collapse"
                                      class="sub-title-content"
                                      href="#collapse{{ roomIndex }}-{{ i }}"
                                      aria-expanded="true"
                                      aria-controls="collapseOne">
                                      {{ rGuestBookMessages?.book?.bookPageGuestText || "Guest " }}
                                      <span *ngIf="rGuestBookPermissions.functionalPermissions.addGuestButton">{{
                                        guest?.guestSerialno
                                      }}</span>
                                    </a>
                                    <i
                                      id="deleteGuest{{ roomIndex }}{{ i }}"
                                      class="fa fa-trash-o remove-address"
                                      aria-hidden="true"
                                      (click)="removeAddress(roomIndex, i)"
                                      *ngIf="i > 0"></i>
                                  </h4>
                                </div>
                                <div id="collapse{{ roomIndex }}-{{ i }}" class="panel-collapse collapse show" role="tabpanel">
                                  <div class="row panel-body custom-panel-body">
                                    <div class="same-name-address" *ngIf="roomIndex > 0 && i == 0">
                                      <mat-checkbox
                                        color="accent"
                                        id="useSameDetails{{ roomIndex }}{{ i }}"
                                        [(ngModel)]="guest.sameDetails"
                                        (ngModelChange)="useSameNamesAndAddress(roomIndex, i)"
                                        [ngModelOptions]="{ standalone: true }"
                                        [disabled]="rooms.isCasinoOffer && rooms.isCasinoOffer != ''">
                                        {{ rGuestBookMessages?.book?.bookUseSameDetails || "Use same Details" }}
                                      </mat-checkbox>
                                    </div>
                                    <div
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.title
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.title
                                      "
                                      class="col-xs-12 col-sm-8 col-sm-6 col-md-6 mTop10">
                                      <mat-form-field>
                                        <mat-select
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_Title || 'Title' }}"
                                          [(ngModel)]="guest.title"
                                          #title="ngModel"
                                          [disabled]="guest?.hasOwnProperty('addNameId') && (i === 0 || (i > 0 && !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests))"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.title &&
                                                rGuestBookPermissions.primaryGuestRequiredPermission.title
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.title &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.title
                                          "
                                          name="title{{ roomIndex }}{{ i }}">
                                          <mat-option value=""></mat-option>
                                          <mat-option [value]="til" *ngFor="let til of ConfigService.Titles"> {{ til }}</mat-option>
                                        </mat-select>
                                        <div *ngIf="!submitted && title.errors && (title.dirty || title.touched)" class="form-text error">
                                          <small [hidden]="!title.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_title || "Title is required!"
                                          }}</small>
                                        </div>
                                        <div
                                          *ngIf="submitted && !title.pristine && title.errors && (title.dirty || title.touched)"
                                          class="form-text error">
                                          <small [hidden]="!title.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_title || "Title is required!"
                                          }}</small>
                                        </div>
                                        <div *ngIf="submitted && title.pristine && title.errors" class="form-text error">
                                          <small [hidden]="!title.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_title || "Title is required!"
                                          }}</small>
                                        </div>
                                      </mat-form-field>
                                    </div>
                                    <!-- Show casino no only for primary guest that too in disabled status! For others just hide that casino no -->
                                    <div
                                      *ngIf="
                                        guest.isCasinoPlayer &&
                                        rGuestBookPermissions.functionalPermissions.casinoNumber_casinoNumberGuestInfoPage &&
                                        guest?.hasOwnProperty('addNameId')
                                      "
                                      class="col-xs-12 col-sm-8 col-sm-6 col-md-6 mTop10">
                                      <mat-form-field>
                                        <input
                                          (keydown.enter)="$event.preventDefault()"
                                          type="text"
                                          id="casinoNumber"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_casinoNo || 'Casino No' }}"
                                          matInput
                                          [(ngModel)]="guest.casinoNo"
                                          #casinoNo="ngModel"
                                          pattern="[a-zA-Z0-9 #\-]*"
                                          name="casinoNo{{ roomIndex }}{{ i }}"
                                          disabled />
                                      </mat-form-field>
                                    </div>
                                    <div class="clearfix clearfix-gap"></div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.firstName
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.firstName
                                      ">
                                      <mat-form-field>
                                        <input
                                          type="text"
                                          id="firstName"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_firstName || 'First Name' }}"
                                          matInput
                                          [(ngModel)]="guest.fName"
                                          maxlength="{{ guestDetailsLength.firstNameLength }}"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.firstName &&
                                                rGuestBookPermissions.primaryGuestRequiredPermission.firstName
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.firstName &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.firstName
                                          "
                                          #fName="ngModel"
                                          [pattern]="
                                            pms === 'lms' ? '^[a-zA-Z]+([\sa-zA-Z]){0,}[^#]*' : '^[a-zA-ZÆØÅæøå]+([\sa-zA-Z]){0,}[^#]*'
                                          "
                                          (blur)="updateAddress(roomIndex, i)"
                                          name="fName{{ roomIndex }}{{ i }}"
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empFName) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                        <mat-hint
                                          *ngIf="guestDetailsLength.lengthHint && guest.fName?.length > 0 && !guest.isCasinoPlayer"
                                          align="end">
                                          {{ guest.fName.length }} /
                                          {{ guestDetailsLength.firstNameLength }}
                                        </mat-hint>
                                        <div *ngIf="!submitted && fName.errors && (fName.dirty || fName.touched)" class="form-text error">
                                          <small [hidden]="!fName.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_firstName || "First Name is required!"
                                          }}</small>
                                          <small [hidden]="!fName.hasError('pattern')">{{
                                            rGuestBookMessages?.book?.bookGuestValidationErrorMessage_firstName ||
                                              "Please enter valid First name"
                                          }}</small>
                                        </div>
                                        <div
                                          *ngIf="submitted && !fName.pristine && fName.errors && (fName.dirty || fName.touched)"
                                          class="form-text error">
                                          <small [hidden]="!fName.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_firstName || "First Name is required!"
                                          }}</small>
                                          <small [hidden]="!fName.hasError('pattern')">{{
                                            rGuestBookMessages?.book?.bookGuestValidationErrorMessage_firstName ||
                                              "Please enter valid First name"
                                          }}</small>
                                        </div>
                                        <div *ngIf="submitted && fName.pristine && fName.errors" class="form-text error">
                                          <small [hidden]="!fName.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_firstName
                                          }}</small>
                                          <small [hidden]="!fName.hasError('pattern')">{{
                                            rGuestBookMessages?.book?.bookGuestValidationErrorMessage_firstName ||
                                              "Please enter valid First name"
                                          }}</small>
                                        </div>
                                      </mat-form-field>
                                    </div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.lastName
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.lastName
                                      ">
                                      <mat-form-field>
                                        <input
                                          type="text"
                                          id="lastName"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_lastName || 'Last Name' }}"
                                          matInput
                                          [(ngModel)]="guest.lName"
                                          maxlength="{{ guestDetailsLength.lastNameLength }}"
                                          #lName="ngModel"
                                          [pattern]="
                                            pms === 'lms' ? '^[a-zA-Z]+([\sa-zA-Z]){0,}[^#]*' : '^[a-zA-ZÆØÅæøå]+([\sa-zA-Z]){0,}[^#]*'
                                          "
                                          (blur)="updateAddress(roomIndex, i)"
                                          name="lName{{ roomIndex }}{{ i }}"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.lastName &&
                                                rGuestBookPermissions.primaryGuestRequiredPermission.lastName
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.lastName &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.lastName
                                          "
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empLName) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                        <mat-hint
                                          *ngIf="guestDetailsLength.lengthHint && guest.lName?.length > 0 && !guest.isCasinoPlayer"
                                          align="end">
                                          {{ guest.lName.length }} /
                                          {{ guestDetailsLength.lastNameLength }}
                                        </mat-hint>
                                        <div *ngIf="!submitted && lName.errors && (lName.dirty || lName.touched)" class="form-text error">
                                          <small [hidden]="!lName.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_lastName || "Last Name is required!"
                                          }}</small>
                                          <small [hidden]="!lName.hasError('pattern')">{{
                                            rGuestBookMessages?.book?.bookGuestValidationErrorMessage_lastName ||
                                              "Please enter valid Last name"
                                          }}</small>
                                        </div>
                                        <div
                                          *ngIf="submitted && !lName.pristine && lName.errors && (lName.dirty || lName.touched)"
                                          class="form-text error">
                                          <small [hidden]="!lName.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_lastName || "Last Name is required!"
                                          }}</small>
                                          <small [hidden]="!lName.hasError('pattern')">{{
                                            rGuestBookMessages?.book?.bookGuestValidationErrorMessage_lastName ||
                                              "Please enter valid Last name"
                                          }}</small>
                                        </div>
                                        <div *ngIf="submitted && lName.pristine && lName.errors" class="form-text error">
                                          <small [hidden]="!lName.errors.required">{{
                                            rGuestBookMessages?.book?.bookGuestRequiredMessage_lastName || "Last Name is required!"
                                          }}</small>
                                          <small [hidden]="!lName.hasError('pattern')">{{
                                            rGuestBookMessages?.book?.bookGuestValidationErrorMessage_lastName ||
                                              "Please enter valid Last name"
                                          }}</small>
                                        </div>
                                      </mat-form-field>
                                    </div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.email
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.email
                                      ">
                                      <mat-form-field
                                        *ngIf="
                                          rGuestBookPermissions.functionalPermissions.maskGuestDetails &&
                                            ((guest.isCasinoPlayer && blockKeyInGuestDetails) || (guest.isCasinoPlayer && !guest.empEmail));
                                          else emailNoMask
                                        ">
                                        <input
                                          type="email"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_email || 'Email' }}"
                                          matInput
                                          [(ngModel)]="guest.maskedEmail"
                                          maxlength="{{ guestDetailsLength.emailIdLength }}"
                                          email
                                          (ngModelChange)="updateMarketingOptIns('email', $event, i)"
                                          name="email{{ roomIndex }}{{ i }}"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.email &&
                                                (rGuestBookPermissions.primaryGuestRequiredPermission.email || marketOptIn.optInEmail)
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.email &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.email
                                          "
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empEmail) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                      </mat-form-field>
                                      <ng-template #emailNoMask>
                                        <mat-form-field>
                                          <input
                                            type="email"
                                            placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_email || 'Email' }}"
                                            matInput
                                            [(ngModel)]="guest.email"
                                            maxlength="{{ guestDetailsLength.emailIdLength }}"
                                            #email="ngModel"
                                            email
                                            (ngModelChange)="updateMarketingOptIns('email', $event, i)"
                                            (blur)="updateAddress(roomIndex, i)"
                                            name="email{{ roomIndex }}{{ i }}"
                                            [required]="
                                              i == 0
                                                ? rGuestBookPermissions.primaryGuestDisplayPermission.email &&
                                                  (rGuestBookPermissions.primaryGuestRequiredPermission.email || marketOptIn.optInEmail)
                                                : rGuestBookPermissions.secondaryGuestDisplayPermission.email &&
                                                  rGuestBookPermissions.secondaryGuestRequiredPermission.email
                                            "
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empEmail) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            " />
                                          <mat-hint
                                            *ngIf="guestDetailsLength.lengthHint && guest.email?.length > 0 && !guest.isCasinoPlayer"
                                            align="end">
                                            {{ guest.email.length }} /
                                            {{ guestDetailsLength.emailIdLength }}
                                          </mat-hint>
                                          <div *ngIf="!submitted && email.errors && (email.dirty || email.touched)" class="form-text error">
                                            <small [hidden]="!email.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_email || "Email ID is required!"
                                            }}</small>
                                            <small [hidden]="!email.hasError('email')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_email ||
                                                "Please enter valid Email address"
                                            }}</small>
                                          </div>
                                          <div
                                            *ngIf="submitted && !email.pristine && email.errors && (email.dirty || email.touched)"
                                            class="form-text error">
                                            <small [hidden]="!email.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_email || "Email ID is required!"
                                            }}</small>
                                            <small [hidden]="!email.hasError('email')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_email ||
                                                "Please enter valid Email address"
                                            }}</small>
                                          </div>
                                          <div *ngIf="submitted && email.pristine && email.errors" class="form-text error">
                                            <small [hidden]="!email.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_email || "Email ID is required!"
                                            }}</small>
                                            <small [hidden]="!email.hasError('email')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_email ||
                                                "Please enter valid Email address"
                                            }}</small>
                                          </div>
                                        </mat-form-field>
                                      </ng-template>
                                    </div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6 same-address"
                                      *ngIf="
                                        i > 0 &&
                                        (rGuestBookPermissions.primaryGuestDisplayPermission.address ||
                                          rGuestBookPermissions.primaryGuestDisplayPermission.pincode ||
                                          rGuestBookPermissions.primaryGuestDisplayPermission.city ||
                                          rGuestBookPermissions.primaryGuestDisplayPermission.state ||
                                          rGuestBookPermissions.primaryGuestDisplayPermission.country) &&
                                        (rGuestBookPermissions.secondaryGuestDisplayPermission.address ||
                                          rGuestBookPermissions.secondaryGuestDisplayPermission.pincode ||
                                          rGuestBookPermissions.secondaryGuestDisplayPermission.city ||
                                          rGuestBookPermissions.secondaryGuestDisplayPermission.state ||
                                          rGuestBookPermissions.secondaryGuestDisplayPermission.country)
                                      ">
                                      <mat-checkbox
                                        color="accent"
                                        id="sameAddress{{ roomIndex }}{{ i }}"
                                        [(ngModel)]="guest.sameAddress"
                                        (ngModelChange)="useSameAddress(roomIndex, i)"
                                        [disabled]="(guest.isCasinoPlayer && !guest.empFName) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests"
                                        name="sameAddress{{ roomIndex }}{{ i }}">
                                        {{ rGuestBookMessages?.book?.bookUseSameAddress || "Use Same Address" }}</mat-checkbox
                                      >
                                    </div>
                                    <div class="clearfix clearfix-gap"></div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.phone
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.phone
                                      ">
                                      <div class="phone-wrap">
                                        <mat-form-field
                                          class="country-selector"
                                          *ngIf="rGuestBookPermissions?.functionalPermissions?.enableCountryDialInCodeSelection">
                                          <mat-select
                                            [id]="'dialogCode' + i"
                                            [name]="'dialogCode' + i"
                                            [(ngModel)]="guest.dialCode?.split('|')[0]"
                                            #dialCode="ngModel"
                                            name="dialCode{{ roomIndex }}{{ i }}"
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empMobile) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            ">
                                            <mat-select-trigger>
                                              <div
                                                [ngStyle]="{
                                                  opacity: !enableKeyInGuestDetails && blockKeyInGuestDetails ? '0.5' : '1'
                                                }">
                                                <span>{{ guest.dialCode?.split("|")[0] }}</span>
                                              </div>
                                            </mat-select-trigger>
                                            <mat-option
                                              *ngFor="let country of countryList"
                                              [value]="country['dial-code']?.split('|')[0]"
                                              (click)="updateDialCode(country, guest)">
                                              <div class="country-list">
                                                <span class="country-name">{{ country.name }}</span>
                                                <span class="country-code">{{ country["dial-code"] }}</span>
                                              </div>
                                            </mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                        <mat-form-field
                                          *ngIf="
                                            rGuestBookPermissions.functionalPermissions.maskGuestDetails &&
                                              ((guest.isCasinoPlayer && blockKeyInGuestDetails) ||
                                                (guest.isCasinoPlayer && !guest.empMobile));
                                            else mobileNoMask
                                          "
                                          class="phone-input">
                                          <input
                                            type="text"
                                            placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_mobile || 'Mobile' }}"
                                            matInput
                                            [(ngModel)]="guest.maskedMobile"
                                            (ngModelChange)="updateMarketingOptIns('mobile', $event, i)"
                                            maxlength="{{ guestDetailsLength.mobileNoLength }}"
                                            minlength="1"
                                            pattern="[0-9]*"
                                            name="mobile{{ roomIndex }}{{ i }}"
                                            [required]="
                                              i == 0
                                                ? rGuestBookPermissions.primaryGuestDisplayPermission.phone &&
                                                  (rGuestBookPermissions.primaryGuestRequiredPermission.phone || marketOptIn.optInCell)
                                                : rGuestBookPermissions.secondaryGuestDisplayPermission.phone &&
                                                  rGuestBookPermissions.secondaryGuestRequiredPermission.phone
                                            "
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empMobile) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            " />
                                        </mat-form-field>
                                        <ng-template #mobileNoMask>
                                          <mat-form-field class="phone-input">
                                            <input
                                              type="text"
                                              placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_mobile || 'Mobile' }}"
                                              matInput
                                              [(ngModel)]="guest.mobile"
                                              maxlength="{{ guestDetailsLength.mobileNoLength }}"
                                              #mobile="ngModel"
                                              minlength="1"
                                              pattern="[0-9]*"
                                              (ngModelChange)="updateMarketingOptIns('mobile', $event, i)"
                                              (blur)="updateAddress(roomIndex, i)"
                                              name="mobile{{ roomIndex }}{{ i }}"
                                              [required]="
                                                i == 0
                                                  ? rGuestBookPermissions.primaryGuestDisplayPermission.phone &&
                                                    (rGuestBookPermissions.primaryGuestRequiredPermission.phone || marketOptIn.optInCell)
                                                  : rGuestBookPermissions.secondaryGuestDisplayPermission.phone &&
                                                    rGuestBookPermissions.secondaryGuestRequiredPermission.phone
                                              "
                                              [disabled]="
                                                (i === 0 ||
                                                  (i > 0 &&
                                                    ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empMobile) ||
                                                    (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                                guest?.hasOwnProperty('addNameId')
                                              " />
                                            <mat-hint
                                              *ngIf="guestDetailsLength?.lengthHint && guest?.mobile?.length > 0 && !guest?.isCasinoPlayer"
                                              align="end">
                                              {{ guest.mobile.length }} /
                                              {{ guestDetailsLength.mobileNoLength }}
                                            </mat-hint>
                                            <div
                                              *ngIf="!submitted && mobile.errors && (mobile.dirty || mobile.touched)"
                                              class="form-text error">
                                              <small [hidden]="!mobile.hasError('required')">{{
                                                rGuestBookMessages?.book?.bookGuestRequiredMessage_mobile || "Mobile Number is required!"
                                              }}</small>
                                              <small
                                                [hidden]="
                                                  !mobile.hasError('pattern') &&
                                                  !mobile.hasError('minlength') &&
                                                  !mobile.hasError('maxlength')
                                                "
                                                >{{
                                                  rGuestBookMessages?.book?.bookGuestValidationErrorMessage_mobile ||
                                                    "Please enter valid Mobile Number"
                                                }}</small
                                              >
                                            </div>
                                            <div
                                              *ngIf="submitted && !mobile.pristine && mobile.errors && (mobile.dirty || mobile.touched)"
                                              class="form-text error">
                                              <small [hidden]="!mobile.hasError('required')">{{
                                                rGuestBookMessages?.book?.bookGuestRequiredMessage_mobile || "Mobile Number is required!"
                                              }}</small>
                                              <small
                                                [hidden]="
                                                  !mobile.hasError('pattern') &&
                                                  !mobile.hasError('minlength') &&
                                                  !mobile.hasError('maxlength')
                                                "
                                                >{{
                                                  rGuestBookMessages?.book?.bookGuestValidationErrorMessage_mobile ||
                                                    "Please enter valid Mobile Number"
                                                }}</small
                                              >
                                            </div>
                                            <div *ngIf="submitted && mobile.pristine && mobile.errors" class="form-text error">
                                              <small [hidden]="!mobile.hasError('required')">{{
                                                rGuestBookMessages?.book?.bookGuestRequiredMessage_mobile || "Mobile Number is required!"
                                              }}</small>
                                              <small
                                                [hidden]="
                                                  !mobile.hasError('pattern') &&
                                                  !mobile.hasError('minlength') &&
                                                  !mobile.hasError('maxlength')
                                                "
                                                >{{
                                                  rGuestBookMessages?.book?.bookGuestValidationErrorMessage_mobile ||
                                                    "Please enter valid Mobile Number"
                                                }}</small
                                              >
                                            </div>
                                          </mat-form-field>
                                        </ng-template>
                                      </div>
                                    </div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.address
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.address
                                      ">
                                      <mat-form-field
                                        *ngIf="
                                          rGuestBookPermissions.functionalPermissions.maskGuestDetails &&
                                            ((guest.isCasinoPlayer && blockKeyInGuestDetails) ||
                                              (guest.isCasinoPlayer && !guest.empAddress) ||
                                              guest.sameAddress);
                                          else addressNoMask
                                        ">
                                        <input
                                          type="text"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_address || 'Address' }}"
                                          id="addresses"
                                          matInput
                                          [(ngModel)]="guest.maskedAddress"
                                          (ngModelChange)="updateMarketingOptIns('address', $event, i)"
                                          maxlength="{{ guestDetailsLength.addressLength }}"
                                          [pattern]="pms === 'lms' ? '^[a-zA-Z0-9#$&,.:;_-]{1,}[a-zA-Z0-9 #$&,.:;_-]*' : null"
                                          name="address{{ roomIndex }}{{ i }}"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.address &&
                                                (rGuestBookPermissions.primaryGuestRequiredPermission.address || marketOptIn.optInMail)
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.address &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.address
                                          "
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empAddress) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                      </mat-form-field>
                                      <ng-template #addressNoMask>
                                        <mat-form-field>
                                          <input
                                            type="text"
                                            id="addresses"
                                            placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_address || 'Address' }}"
                                            matInput
                                            [(ngModel)]="guest.address"
                                            (ngModelChange)="updateMarketingOptIns('address', $event, i)"
                                            maxlength="{{ guestDetailsLength.addressLength }}"
                                            [pattern]="pms === 'lms' ? '^[a-zA-Z0-9#$&,.:;_-]{1,}[a-zA-Z0-9 #$&,.:;_-]*' : null"
                                            #address="ngModel"
                                            (blur)="updateAddress(roomIndex, i)"
                                            name="address{{ roomIndex }}{{ i }}"
                                            [required]="
                                              i == 0
                                                ? rGuestBookPermissions.primaryGuestDisplayPermission.address &&
                                                  (rGuestBookPermissions.primaryGuestRequiredPermission.address || marketOptIn.optInMail)
                                                : rGuestBookPermissions.secondaryGuestDisplayPermission.address &&
                                                  rGuestBookPermissions.secondaryGuestRequiredPermission.address
                                            "
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empAddress) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            " />
                                          <mat-hint *ngIf="guestDetailsLength.lengthHint && guest.address?.length > 0" align="end">
                                            {{ guest.address.length }} /
                                            {{ guestDetailsLength.addressLength }}
                                          </mat-hint>
                                          <div
                                            *ngIf="!submitted && address.errors && (address.dirty || address.touched)"
                                            class="form-text error">
                                            <small [hidden]="!address.hasError('required')">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_address || "Address is required!"
                                            }}</small>
                                            <small [hidden]="!address.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_address ||
                                                "Please enter valid Address"
                                            }}</small>
                                          </div>
                                          <div
                                            *ngIf="submitted && !address.pristine && address.errors && (address.dirty || address.touched)"
                                            class="form-text error">
                                            <small [hidden]="!address.hasError('required')">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_address || "Address is required!"
                                            }}</small>
                                            <small [hidden]="!address.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_address ||
                                                "Please enter valid Address"
                                            }}</small>
                                          </div>
                                          <div *ngIf="submitted && address.pristine && address.errors" class="form-text error">
                                            <small [hidden]="!address.hasError('required')">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_address || "Address is required!"
                                            }}</small>
                                            <small [hidden]="!address.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_address ||
                                                "Please enter valid Address"
                                            }}</small>
                                          </div>
                                        </mat-form-field>
                                      </ng-template>
                                    </div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.pincode
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.pincode
                                      ">
                                      <mat-form-field
                                        *ngIf="
                                          rGuestBookPermissions.functionalPermissions.maskGuestDetails &&
                                            ((guest.isCasinoPlayer && blockKeyInGuestDetails) ||
                                              (guest.isCasinoPlayer && !guest.empPostalCode) ||
                                              guest.sameAddress);
                                          else zipCodeNoMask
                                        ">
                                        <input
                                          type="text"
                                          id="zipCode"
                                          minlength="2"
                                          [pattern]="pms === 'lms' ? '^[a-zA-Z0-9]{1,}[a-zA-Z0-9\s\-]*' : null"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_postalCode || 'Postal Code' }}"
                                          matInput
                                          [(ngModel)]="guest.maskedPostalCode"
                                          maxlength="{{ guestDetailsLength.postalCodeLength }}"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.pincode &&
                                                rGuestBookPermissions.primaryGuestRequiredPermission.pincode
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.pincode &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.pincode
                                          "
                                          name="postalCode{{ roomIndex }}{{ i }}"
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empPostalCode) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                      </mat-form-field>
                                      <ng-template #zipCodeNoMask>
                                        <mat-form-field>
                                          <input
                                            type="text"
                                            id="zipCode"
                                            minlength="2"
                                            pattern="^[a-zA-Z0-9]{1,}[a-zA-Z0-9\s\-]*"
                                            placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_postalCode || 'Postal Code' }}"
                                            matInput
                                            [(ngModel)]="guest.postalCode"
                                            maxlength="{{ guestDetailsLength.postalCodeLength }}"
                                            [required]="
                                              i == 0
                                                ? rGuestBookPermissions.primaryGuestDisplayPermission.pincode &&
                                                  rGuestBookPermissions.primaryGuestRequiredPermission.pincode
                                                : rGuestBookPermissions.secondaryGuestDisplayPermission.pincode &&
                                                  rGuestBookPermissions.secondaryGuestRequiredPermission.pincode
                                            "
                                            #postalCode="ngModel"
                                            (blur)="getZipCodeDetails(roomIndex, i, $event); updateAddress(roomIndex, i)"
                                            name="postalCode{{ roomIndex }}{{ i }}"
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empPostalCode) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            " />
                                          <mat-hint *ngIf="guestDetailsLength.lengthHint && guest.postalCode?.length > 0" align="end">
                                            {{ guest.postalCode.length }}
                                            /
                                            {{ guestDetailsLength.postalCodeLength }}
                                          </mat-hint>
                                          <div
                                            *ngIf="!submitted && postalCode.errors && (postalCode.dirty || postalCode.touched)"
                                            class="form-text error">
                                            <small [hidden]="!postalCode.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_postalCode || "Postal Code is required!"
                                            }}</small>
                                            <small [hidden]="!postalCode.hasError('pattern') && !postalCode.hasError('minlength')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_postalCode ||
                                                "Please enter valid Postal Code"
                                            }}</small>
                                          </div>
                                          <div
                                            *ngIf="
                                              submitted &&
                                              !postalCode.pristine &&
                                              postalCode.errors &&
                                              (postalCode.dirty || postalCode.touched)
                                            "
                                            class="form-text error">
                                            <small [hidden]="!postalCode.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_postalCode || "Postal Code is required!"
                                            }}</small>
                                            <small [hidden]="!postalCode.hasError('pattern') && !postalCode.hasError('minlength')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_postalCode ||
                                                "Please enter valid Postal Code"
                                            }}</small>
                                          </div>
                                          <div *ngIf="submitted && postalCode.pristine && postalCode.errors" class="form-text error">
                                            <small [hidden]="!postalCode.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_postalCode || "Postal Code is required!"
                                            }}</small>
                                            <small [hidden]="!postalCode.hasError('pattern') && !postalCode.hasError('minlength')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_postalCode ||
                                                "Please enter valid Postal Code"
                                            }}</small>
                                          </div>
                                        </mat-form-field>
                                      </ng-template>
                                    </div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.city
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.city
                                      ">
                                      <mat-form-field
                                        *ngIf="
                                          rGuestBookPermissions.functionalPermissions.maskGuestDetails &&
                                            ((guest.isCasinoPlayer && blockKeyInGuestDetails) ||
                                              (guest.isCasinoPlayer && !guest.empCity) ||
                                              guest.sameAddress);
                                          else cityNoMask
                                        ">
                                        <input
                                          type="text"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_city || 'City' }}"
                                          id="cityName"
                                          matInput
                                          [(ngModel)]="guest.maskedCity"
                                          maxlength="{{ guestDetailsLength.cityLength }}"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.city &&
                                                rGuestBookPermissions.primaryGuestRequiredPermission.city
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.city &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.city
                                          "
                                          [pattern]="pms === 'lms' ? '^[a-zA-Z]{1,}[a-zA-Z ]*' : null"
                                          name="city{{ roomIndex }}{{ i }}"
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empCity) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                      </mat-form-field>
                                      <ng-template #cityNoMask>
                                        <mat-form-field>
                                          <input
                                            type="text"
                                            id="cityName"
                                            placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_city || 'City' }}"
                                            matInput
                                            [(ngModel)]="guest.city"
                                            maxlength="{{ guestDetailsLength.cityLength }}"
                                            [required]="
                                              i == 0
                                                ? rGuestBookPermissions.primaryGuestDisplayPermission.city &&
                                                  rGuestBookPermissions.primaryGuestRequiredPermission.city
                                                : rGuestBookPermissions.secondaryGuestDisplayPermission.city &&
                                                  rGuestBookPermissions.secondaryGuestRequiredPermission.city
                                            "
                                            #city="ngModel"
                                            [pattern]="pms === 'lms' ? '^[a-zA-Z]{1,}[a-zA-Z ]*' : null"
                                            (blur)="updateAddress(roomIndex, i)"
                                            name="city{{ roomIndex }}{{ i }}"
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empCity) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            " />
                                          <mat-hint *ngIf="guestDetailsLength.lengthHint && guest.city?.length > 0" align="end">
                                            {{ guest.city.length }} /
                                            {{ guestDetailsLength.cityLength }}
                                          </mat-hint>
                                          <div *ngIf="!submitted && city.errors && (city.dirty || city.touched)" class="form-text error">
                                            <small [hidden]="!city.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_city || "City is required!"
                                            }}</small>
                                            <small [hidden]="!city.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_city ||
                                                "Please enter valid City name"
                                            }}</small>
                                          </div>
                                          <div
                                            *ngIf="submitted && !city.pristine && city.errors && (city.dirty || city.touched)"
                                            class="form-text error">
                                            <small [hidden]="!city.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_city || "City is required!"
                                            }}</small>
                                            <small [hidden]="!city.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_city ||
                                                "Please enter valid City name"
                                            }}</small>
                                          </div>
                                          <div *ngIf="submitted && city.pristine && city.errors" class="form-text error">
                                            <small [hidden]="!city.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_city || "City is required!"
                                            }}</small>
                                            <small [hidden]="!city.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_city ||
                                                "Please enter valid City name"
                                            }}</small>
                                          </div>
                                        </mat-form-field>
                                      </ng-template>
                                    </div>
                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.state
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.state
                                      ">
                                      <mat-form-field
                                        *ngIf="
                                          rGuestBookPermissions.functionalPermissions.maskGuestDetails &&
                                            ((guest.isCasinoPlayer && blockKeyInGuestDetails) ||
                                              (guest.isCasinoPlayer && !guest.empState) ||
                                              guest.sameAddress);
                                          else stateNoMask
                                        ">
                                        <input
                                          type="text"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_state || 'State/Province' }}"
                                          id="stateName"
                                          [pattern]="pms === 'lms' ? '^[a-zA-Z]{1,}[a-zA-Z ]*' : null"
                                          matInput
                                          [(ngModel)]="guest.maskedState"
                                          maxlength="{{ guestDetailsLength.stateLength }}"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.state &&
                                                rGuestBookPermissions.primaryGuestRequiredPermission.state
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.state &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.state
                                          "
                                          name="state{{ roomIndex }}{{ i }}"
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empState) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                      </mat-form-field>
                                      <ng-template #stateNoMask>
                                        <mat-form-field>
                                          <input
                                            type="text"
                                            id="stateName"
                                            placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_state || 'State/Province' }}"
                                            [pattern]="pms === 'lms' ? '^[a-zA-Z]{1,}[a-zA-Z ]*' : null"
                                            matInput
                                            [(ngModel)]="guest.state"
                                            maxlength="{{ guestDetailsLength.stateLength }}"
                                            [required]="
                                              i == 0
                                                ? rGuestBookPermissions.primaryGuestDisplayPermission.state &&
                                                  rGuestBookPermissions.primaryGuestRequiredPermission.state
                                                : rGuestBookPermissions.secondaryGuestDisplayPermission.state &&
                                                  rGuestBookPermissions.secondaryGuestRequiredPermission.state
                                            "
                                            #state="ngModel"
                                            (blur)="updateAddress(roomIndex, i)"
                                            name="state{{ roomIndex }}{{ i }}"
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empState) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            " />
                                          <mat-hint *ngIf="guestDetailsLength.lengthHint && guest.state?.length > 0" align="end">
                                            {{ guest.state.length }} /
                                            {{ guestDetailsLength.stateLength }}
                                          </mat-hint>
                                          <div *ngIf="!submitted && state.errors && (state.dirty || state.touched)" class="form-text error">
                                            <small [hidden]="!state.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_state || "State/Province is required!"
                                            }}</small>
                                            <small [hidden]="!state.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_state ||
                                                "Please enter valid State/Province name"
                                            }}</small>
                                          </div>
                                          <div
                                            *ngIf="submitted && !state.pristine && state.errors && (state.dirty || state.touched)"
                                            class="form-text error">
                                            <small [hidden]="!state.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_state || "State/Province is required!"
                                            }}</small>
                                            <small [hidden]="!state.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_state ||
                                                "Please enter valid State/Province name"
                                            }}</small>
                                          </div>
                                          <div *ngIf="submitted && state.pristine && state.errors" class="form-text error">
                                            <small [hidden]="!state.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_state || "State/Province is required!"
                                            }}</small>
                                            <small [hidden]="!state.hasError('pattern')">{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_state ||
                                                "Please enter valid State/Province name"
                                            }}</small>
                                          </div>
                                        </mat-form-field>
                                      </ng-template>
                                    </div>

                                    <div
                                      class="col-xs-12 col-sm-6 col-md-6"
                                      *ngIf="
                                        i == 0
                                          ? rGuestBookPermissions.primaryGuestDisplayPermission.country
                                          : rGuestBookPermissions.secondaryGuestDisplayPermission.country
                                      ">
                                      <mat-form-field
                                        *ngIf="
                                          rGuestBookPermissions.functionalPermissions.maskGuestDetails &&
                                            ((guest.isCasinoPlayer && blockKeyInGuestDetails) ||
                                              (guest.isCasinoPlayer && !guest.empCountry) ||
                                              guest.sameAddress);
                                          else countryNoMask
                                        ">
                                        <input
                                          type="text"
                                          placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_country || 'Country' }}"
                                          id="countryName"
                                          matInput
                                          [(ngModel)]="guest.maskedCountry"
                                          #country="ngModel"
                                          [required]="
                                            i == 0
                                              ? rGuestBookPermissions.primaryGuestDisplayPermission.country &&
                                                rGuestBookPermissions.primaryGuestRequiredPermission.country
                                              : rGuestBookPermissions.secondaryGuestDisplayPermission.country &&
                                                rGuestBookPermissions.secondaryGuestRequiredPermission.country
                                          "
                                          name="country{{ roomIndex }}{{ i }}"
                                          [disabled]="
                                            (i === 0 ||
                                              (i > 0 &&
                                                ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empCountry) ||
                                                (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                            guest?.hasOwnProperty('addNameId')
                                          " />
                                      </mat-form-field>
                                      <ng-template #countryNoMask>
                                        <mat-form-field>
                                          <input
                                            [disabled]="
                                              (i === 0 ||
                                                (i > 0 &&
                                                  ((guest.isCasinoPlayer && enableKeyInGuestDetails && !guest.empCountry) ||
                                                  (guest.isCasinoPlayer && blockKeyInGuestDetails)) || !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)) &&
                                              guest?.hasOwnProperty('addNameId')
                                            "
                                            matInput
                                            placeholder="{{ rGuestBookMessages?.book?.bookGuestPlaceholder_country || 'Country' }}"
                                            aria-label="Country"
                                            (blur)="updateAddress(roomIndex); updateCountry($event, guest)"
                                            name="country{{ roomIndex }}{{ i }}"
                                            [matAutocomplete]="auto"
                                            #country="ngModel"
                                            appCountryValidator
                                            [countryList]="guest.countryList"
                                            [countryCodeKey]="countryCodeKey"
                                            [(ngModel)]="guest.country"
                                            class="c3"
                                            (ngModelChange)="resetCountryDropDown(guest.country)"
                                            [required]="
                                              i == 0
                                                ? rGuestBookPermissions.primaryGuestDisplayPermission.country &&
                                                  rGuestBookPermissions.primaryGuestRequiredPermission.country
                                                : rGuestBookPermissions.secondaryGuestDisplayPermission.country &&
                                                  rGuestBookPermissions.secondaryGuestRequiredPermission.country
                                            " />
                                          <button
                                            type="button"
                                            [disabled]="
                                            i === 0 || (!enableKeyInGuestDetails && (blockKeyInGuestDetails || guest.sameAddress)) || (i > 0 && !reservationData?.canBeAllowedToModify?.[0]?.additionalGuests)
                                            "
                                            (keydown.enter)="$event.preventDefault()"
                                            id="countryClear"
                                            name="countryClear{{ roomIndex }}{{ i }}"
                                            mat-button
                                            *ngIf="guest.country"
                                            matSuffix
                                            mat-icon-button
                                            (click)="guest.country = ''; guest.countryList = countryList"
                                            class="mr-1">
                                            <mat-icon class="clearCountryText"> clear</mat-icon>
                                          </button>
                                          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                            <mat-option
                                              *ngFor="let state of guest.countryList | countryFilter: guest.country; trackBy: customTrackBy"
                                              [value]="state[countryCodeKey]">
                                              {{ state.name }}
                                            </mat-option>
                                          </mat-autocomplete>
                                          <div
                                            *ngIf="!submitted && country.errors && (country.dirty || country.touched)"
                                            class="form-text error">
                                            <small [hidden]="!country.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_country || "Country is required!"
                                            }}</small>
                                          </div>
                                          <div
                                            *ngIf="submitted && !country.pristine && country.errors && (country.dirty || country.touched)"
                                            class="form-text error">
                                            <small [hidden]="!country.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_country || "Country is required!"
                                            }}</small>
                                          </div>
                                          <div *ngIf="submitted && country.pristine && country.errors" class="form-text error">
                                            <small [hidden]="!country.errors.required">{{
                                              rGuestBookMessages?.book?.bookGuestRequiredMessage_country || "Country is required!"
                                            }}</small>
                                          </div>
                                          <div *ngIf="country.errors?.countryCode" class="form-text error">
                                            <small>{{
                                              rGuestBookMessages?.book?.bookGuestValidationErrorMessage_country ||
                                                "Please enter valid Country name"
                                            }}</small>
                                          </div>
                                        </mat-form-field>
                                      </ng-template>
                                    </div>
                                    <div
                                      class="error-note col-xs-12"
                                      *ngIf="!enableKeyInGuestDetails && rooms.isCasinoOffer && rooms.isCasinoOffer != '' && i == 0">
                                      <span>
                                        <i aria-hidden="true" class="fas fa-info-circle"></i>
                                      </span>
                                      {{ rGuestBookMessages?.book?.bookMessage6 || "Guest details for casino Offers are non-editable." }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                            <div class="grid-wrapper">
                              <div
                                class="col-8 mBot10"
                                *ngIf="rGuestBookPermissions.functionalPermissions.guestCommentDisplayPermission"></div>
                              <div
                                *ngIf="rGuestBookPermissions.functionalPermissions.addGuestButton && !rooms.restrictAdditionalGuest && reservationData?.canBeAllowedToModify?.[0]?.additionalGuests"
                                class="add-name-block"
                                [ngStyle]="{
                                  'margin-top': !rGuestBookPermissions.functionalPermissions.guestCommentDisplayPermission ? 0 : ''
                                }"
                                [ngClass]="{
                                  'col-4': rGuestBookPermissions.functionalPermissions.guestCommentDisplayPermission,
                                  'col-12': !rGuestBookPermissions.functionalPermissions.guestCommentDisplayPermission
                                }">
                                <a (click)="addNewGuest(roomIndex)" class="pull-right" (ngModelChange)="updateAddress(roomIndex, 0)">
                                  <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                  {{ rGuestBookMessages?.book?.bookAddNewGuest || "Guest" }}
                                </a>
                              </div>
                            </div>
                            <div class="clearfix"></div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
